import Button from "../../../components/Comon/Button/Button";
import VideoPlayer from "../../../components/Survey/VideoPlayer/VideoPlayer";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";

export default function WellnessSurveyWelcomeScreen({
                                                        patient,
                                                        settingsData,
                                                        themeColor,
                                                        handleWelcomeNext = () => {},
                                                    })
{
    const { i18n } = useTranslation();
    const [videoSize, setVideoSize] = useState({ width: 600, height: 405 });
    const adjustVideoSize = () => {
        if (window.screen.width < 641) {
            setVideoSize({
                width: 297,
                height: 200,
            });
        } else {
            setVideoSize({
                width: 600,
                height: 405,
            });
        }
    };
    useEffect(() => {
        adjustVideoSize();

        function handleResize() {
            adjustVideoSize();
        }

        window.addEventListener("resize", handleResize);
    }, []);


    return <div
        style={{
            width:'100%',
            display:'grid',
            gridTemplateColumns:settingsData?.welcomeVideoLink ? '1fr 1fr' : '1fr',
            alignItems:'center',
            justifyContent:'center',
            gap:'50px',
        }}
    >
        <div style={{display:'flex',justifyContent:'center',alignItems:'center', flexDirection:'column'}}>
            <div style={{display:'flex',justifyContent:'center',alignItems:'center', flexDirection:'column', maxWidth:'700px'}}>
                <div className={"helloDiv"} style={{ borderColor: themeColor }}>{settingsData?.welcomeSectionTitle}</div>
                <div className={"headline"}>{settingsData?.welcomeTitle} {patient?.name}</div>
                <p
                    style={{ margin: 0, textAlign:'center' }}
                    className="text"
                >
                    {settingsData?.welcomeDescription}
                </p>

                <div
                    style={{ display:'flex', justifyContent:'center',alignItems:'center'}}
                >
                    <div className={"presentContainer"} onClick={() => handleWelcomeNext()}>
                        <Button
                            color={themeColor}
                            mode={"small"}
                            text={i18n.t("startSurvey")}
                        />
                    </div>
                </div>
            </div>
        </div>


        {settingsData?.welcomeVideoLink &&
            <div style={{marginTop:'30px'}}>
                <VideoPlayer
                    url={settingsData?.welcomeVideoLink}
                    themeColor={themeColor}
                    videoSize={videoSize}
                    id="SurveyHomePage"
                />
            </div>
        }
    </div>
}
